const support_chat_publishers = [
  "Publisher name",
  "Phone",
  "MOU Status",
  "Publication House",
  "Ticket Status",
  "Actions",
];

const support_chat_authors = [
  "Author name",
  "Phone",
  "MOU Status",
  "Publication House",
  "Ticket Status",
  "Actions",
];

const support_chat_schools = [
  "School name",
  "Phone",
  "MOU Status",
  "Total Teachers/Teachers Allowed",
  "Total Students/Students Allowed",
  "Actions",
];

const schools_requests = [
  "School name",
  "Phone",
  "Total Teachers/Teachers Allowed",
  "Total Students/Students Allowed",
  "Status",
  "Actions",
];

const partners_request = [
  "Name",
  "Phone",
  "Role",
  "MOU Status",
  "Actions",
];

const pending_mous = [
  "Name",
  "Phone",
  "Role",
  "MOU Status",
  "Actions",
];

const headers_enums = {
  support_chat_publishers: 0,
  support_chat_authors: 1,
  support_chat_schools: 2,
  schools_requests: 3,
  partners_request: 4,
  pending_mous: 5
};

export {
  support_chat_publishers,
  support_chat_authors,
  support_chat_schools,
  schools_requests,
  partners_request,
  pending_mous,
  headers_enums,
};
